export default {
  "intro.text.one":
    "This year’s Tour de France promises another epic battle, one we face together. That’s why our limited edition jersey is inspired by The Swarm: a testament to the power of unity in motion. This way we achieve what no single bee could do alone.",
  "intro.cta":
    'Sign up, shape The Swarm on our jersey and get <span class="cta__discount">10% off</span>.',
  "intro.button": "Sign up",
  "thanks.title": "Thanks for signing up!",
  "thanks.text.one":
    "You helped shape The Swarm. You’ll soon receive 10% off in your inbox!",
  "form.label.nameAndEmail":
    "Enter your name and email address to shape The Swarm.",
  "form.placeholder.name": "First name",
  "form.placeholder.email": "Email address",
  "form.label.newsletter":
    "Yes, I want to stay informed about the latest news and offers from Team Visma | Lease a Bike.",
  "form.label.terms":
    'Yes, I agree to the <a href="https://www.teamvismaleaseabike.com/privacy/" target="_blank">privacy policy</a>.',
  "form.button.submit": "Continue",
  "form.button.submitting": "Sending...",
  "form.error.name": "This field is required",
  "form.error.email.required": "This field is required",
  "form.error.email.invalid": "Please enter a valid email address",
  "form.error.terms": "You must agree to the terms",
  "form.error.submit":
    "Something went wrong while submitting this form. Please try again.",
};
